<template>
  <div class="grid">
    <v-progress-linear
      color="warning"
      indeterminate
      rounded
      height="3"
      v-if="isLoading || disableSaveBtn"
    ></v-progress-linear>
    <v-form
      ref="form"
      lazy-validation
      v-on:submit.prevent
      v-if="editedItem && !isLoading"
    >
      <div class="grid-title">
        <h4>
          {{
            $t(
              isAddNew
                ? "_ACTIVITY.HOTEL_ROOM_PLAN_CREATE"
                : "_ACTIVITY.HOTEL_ROOM_PLAN_UPDATE"
            )
          }}
          - {{ $t("CHAIN") }}
        </h4>
      </div>
      <div class="grid-body p-3 border-top-unset mb-4">
        <v-row>
          <v-col sm="12">
            <v-tabs v-model="tab" class="pl-0">
              <v-tab>{{ $t("DEFAULT") }}</v-tab>
              <v-tab>{{ $t("VIETNAMESE") }}</v-tab>
              <v-tab>{{ $t("ENGLISH") }}</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-row>
                  <v-col sm="12">
                    <label>{{ $t("SELLING_PACKAGE") }} *</label>
                    <v-text-field
                      v-model="editedItem.nameVi"
                      counter
                      maxlength="250"
                      class="input-counter"
                      :rules="ruleName"
                      outlined
                      dense
                      v-on:keyup="updateRoomTitle(editedItem.nameVi)"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col sm="12">
                    <label class="mb-1">{{ $t("SERVICE.BENEFIT") }}</label>
                    <tinycme-editor
                      v-model="editedItem.benefitVi"
                      :lang="sysLang"
                      @input="updateRoomBenefit(editedItem.benefitVi)"
                    ></tinycme-editor>
                  </v-col>
                  <v-col sm="12">
                    <label>{{ $t("DESCRIPTION_INFO") }}</label>
                    <v-textarea
                      :rows="3"
                      :rules="ruleDescNotRequired"
                      counter="3000"
                      maxlength="3000"
                      class="input-counter"
                      v-model="editedItem.descriptionVi"
                      dense
                      outlined
                      v-on:keyup="
                        updateRoomDescription(editedItem.descriptionVi)
                      "
                    >
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item>
                <v-row>
                  <v-col sm="12">
                    <label>{{ $t("NAME_SELLING_PACKAGE") }} *</label>
                    <v-text-field
                      v-model="
                        editedItem.i18ns.find((x) => x.lang == 'vi').name
                      "
                      counter
                      maxlength="250"
                      class="input-counter"
                      :rules="ruleName"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                  <v-col sm="12">
                    <label class="mb-1">{{ $t("SERVICE.BENEFIT") }}</label>
                    <tinycme-editor
                      v-model="
                        editedItem.i18ns.find((x) => x.lang == 'vi').benefit
                      "
                      :lang="sysLang"
                    ></tinycme-editor>
                  </v-col>
                  <v-col sm="12">
                    <label>{{ $t("DESCRIPTION_INFO") }}</label>
                    <v-textarea
                      :rows="3"
                      :rules="ruleDescNotRequired"
                      counter="3000"
                      maxlength="3000"
                      class="input-counter"
                      v-model="
                        editedItem.i18ns.find((x) => x.lang == 'vi').description
                      "
                      dense
                      outlined
                    >
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item>
                <v-row>
                  <v-col sm="12">
                    <label>{{ $t("NAME_SELLING_PACKAGE") }} *</label>
                    <v-text-field
                      v-model="
                        editedItem.i18ns.find((x) => x.lang == 'en').name
                      "
                      counter
                      maxlength="250"
                      class="input-counter"
                      :rules="ruleName"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                  <v-col sm="12">
                    <label class="mb-1">{{ $t("SERVICE.BENEFIT") }}</label>
                    <tinycme-editor
                      v-model="
                        editedItem.i18ns.find((x) => x.lang == 'en').benefit
                      "
                      :lang="sysLang"
                    ></tinycme-editor>
                  </v-col>
                  <v-col sm="12">
                    <label>{{ $t("DESCRIPTION_INFO") }}</label>
                    <v-textarea
                      :rows="3"
                      :rules="ruleDescNotRequired"
                      counter="3000"
                      maxlength="3000"
                      class="input-counter"
                      v-model="
                        editedItem.i18ns.find((x) => x.lang == 'en').description
                      "
                      dense
                      outlined
                    >
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>

        <v-divider />
        <div>
          <label class="label-title">{{ $t("SELLING_PACKAGE_INFO") }}</label
          ><br />
          <v-row>
            <v-col sm="3" class="pb-0">
              <label>{{ $t("_SERVICE_PACKAGE.SALE_PACKAGE_CODE") }} *</label>
              <v-text-field
                v-model="editedItem.ratePlanCode"
                :disabled="isDisableSalePackageCode"
                :rules="ruleCode"
                outlined
                counter
                maxlength="20"
                class="input-counter code"
                dense
              >
              </v-text-field>
            </v-col>
            <v-col sm="3" class="pb-0">
              <label>{{ $t("MEALS_INCLUDE") }}</label>

              <v-select
                item-text="text"
                item-value="value"
                :items="select.meals"
                v-model="editedItem.lstMealId"
                multiple
                outlined
                dense
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @click="toggleMeal">
                    <v-list-item-action>
                      <v-icon
                        :color="
                          editedItem.lstMealId.length > 0
                            ? 'indigo darken-4'
                            : ''
                        "
                      >
                        {{ iconMeal }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t("ALL") }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-0 mb-0"></v-divider>
                </template>
              </v-select>
            </v-col>
            <v-col sm="3" class="pb-0">
              <label>{{ $t("_SERVICE_PACKAGE.AGE_MAX_CHILD") }}</label>
              <v-select
                :items="select.child"
                v-model="editedItem.ageMaxChild"
                outlined
                dense
              >
              </v-select>
            </v-col>
            <v-col sm="3" class="pb-0">
              <label>{{ $t("_SERVICE_PACKAGE.AGE_MAX_BABY") }}</label>
              <v-select
                :items="select.child"
                v-model="editedItem.ageMaxBaby"
                dense
                outlined
              >
              </v-select>
            </v-col>
            <v-col sm="3" class="pb-0">
              <v-checkbox
                color="indigo darken-3"
                :label="$t('ACTIVATE')"
                v-model="editedItem.status"
              />
            </v-col>
            <v-col sm="3" class="pb-0">
              <v-checkbox
                color="indigo darken-3"
                :label="$t('INCLUDED_TAX')"
                :value="editedItem.includedTax"
                v-model="editedItem.includedTax"
              ></v-checkbox>
            </v-col>
          </v-row>
        </div>
        <v-divider />
        <div>
          <label class="label-title">{{ $t("_ACTIVITY.APPLY_DATE") }}</label
          ><br />
          <v-row>
            <v-col sm="6" class="pb-0">
              <v-row class="align-center">
                <v-col sm="3">
                  <label>{{ $t("TIME_STAY") }}</label>
                </v-col>
                <v-col sm="9">
                  <v-radio-group
                    row
                    v-model="editedItem.session"
                    class="pl-2 pt-0 mt-0"
                    @change="isConfirmSave = true"
                  >
                    <v-radio
                      color="indigo darken-3"
                      :label="$t('ALWAYS')"
                      :value="false"
                    ></v-radio>
                    <v-radio
                      color="indigo darken-3"
                      :label="$t('IN_PERIOD')"
                      :value="true"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row class="align-center mt-0">
                <v-col sm="6" class="pb-0 pt-0">
                  <date-picker
                    :model.sync="editedItem.startDate"
                    :disabled="!editedItem.session"
                    :min="currentDate()"
                    class="outlined"
                    @changeData="isConfirmSave = true"
                    :error.sync="error.startDate.error"
                    :placeholder="$t('FROM_DATE')"
                  />
                </v-col>
                <v-col sm="6" class="pb-0 pt-0">
                  <date-picker
                    :model.sync="editedItem.endDate"
                    :disabled="!editedItem.session"
                    :min="editedItem.startDate"
                    @changeData="isConfirmSave = true"
                    :error.sync="error.endDate.error"
                    :placeholder="$t('TO_DATE')"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col sm="6" class="pb-0">
              <v-row class="align-center">
                <v-col>
                  <label>{{ $t("_SERVICE_PACKAGE.DAY_APPLY_IN_WEEK") }}</label>
                </v-col>
              </v-row>
              <v-row class="align-center mt-0">
                <v-col class="pb-0 pt-0">
                  <v-layout wrap>
                    <v-chip-group
                      v-model="weekend"
                      column
                      multiple
                      @change="isConfirmSave = true"
                      active-class="primary"
                    >
                      <v-chip
                        v-for="date in daysOfWeek"
                        :value="date.date"
                        class="chip-date"
                      >
                        {{ date.text }}
                      </v-chip>
                    </v-chip-group>
                  </v-layout>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>

        <v-row>
          <v-col sm="12" class="pb-0">
            <label>{{ $t("NOT_APPLY_RANGE_DATE") }}</label>
            <v-row>
              <v-col
                sm="6"
                class="pt-0"
                v-for="(range, i) in editedItem.rateBlackouts"
                :key="i"
              >
                <v-row class="align-center">
                  <v-col sm="6" class="pb-0 pt-0">
                    <date-picker
                      :model.sync="range.startDate"
                      :min="currentDate()"
                      class="outlined"
                      @changeData="isConfirmSave = true"
                      :placeholder="$t('FROM_DATE')"
                    />
                  </v-col>
                  <v-col sm="5" class="pb-0 pt-0 pr-0">
                    <date-picker
                      :model.sync="range.endDate"
                      :min="range.startDate"
                      @changeData="isConfirmSave = true"
                      :placeholder="$t('TO_DATE')"
                    />
                  </v-col>
                  <v-col sm="1">
                    <v-icon
                      color="error"
                      @click="
                        removeRangeApplyDate(i);
                        isConfirmSave = true;
                      "
                      >delete</v-icon
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <div>
              <v-btn
                small
                class="btn-expand mt-1"
                outlined
                depressed
                @click="
                  addnotApplyDates();
                  isConfirmSave = true;
                "
              >
                <v-icon> add </v-icon>
                {{ $t("ADD_RANGE_DAYS_NOT_APPLY") }}
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-divider />
        <div class="d-flex">
          <!-- <div class="w-50 pr-3">
            <label class="label-title pb-3">{{ $t("ASSIGN_ROOM_TYPE") }}</label>
            <v-autocomplete item-text="text" item-value="value" :items="listRooms" v-model="editedItem.roomTypeIds" outlined
              chips dense multiple>
              <template v-slot:prepend-item>
                <p class="mx-3 mt-1"> <a class="text-primary"
                    @click=" editedItem.roomTypeIds = listRooms.map(e => e.value)">{{
                      $t('SELECT_ALL') }}</a>
                  | <a class="text-primary" @click=" editedItem.roomTypeIds = []">{{
                    $t('UN_SELECT_ALL') }}</a>
                </p>
              </template>
              <template v-slot:selection="{ item, index }">
                <v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs" :input-value="item.selected"
                  close @click:close=" removeChips(index, editedItem.roomTypeIds)" @click=" item.select">
                  <span>{{ item.text }}</span>
                </v-chip>
                <span v-if="index === 2" class="grey--text caption">(+{{
                  editedItem.roomTypeIds.length - 2 }})</span>
              </template>
              <template slot="no-data">
                <div class="no-data">{{ $t("NO_DATA") }}</div>
              </template>
            </v-autocomplete>
          </div> -->
          <div class="w-50 pr-3">
            <label class="label-title pb-3">{{
              $t("ASSIGN_RATE_CATEGORY")
            }}</label>
            <v-autocomplete
              item-text="text"
              item-value="value"
              :items="listCategory"
              v-model="editedItem.rateCategoryId"
              outlined
              dense
            >
              <template slot="no-data">
                <div class="no-data">{{ $t("NO_DATA") }}</div>
              </template>
            </v-autocomplete>
          </div>
        </div>
        <v-divider />

        <div class="d-flex">
          <div class="w-50 pr-3">
            <div class="align-center d-flex mb-2">
              <div class="mr-3">
                <label class="label-title">{{ $t("TRAVEL_AGENT") }}</label>
              </div>
              <div>
                <v-radio-group
                  row
                  v-model="travelAgentGeneral"
                  class="pl-2 pt-0 mt-0"
                  @change="editedItem.travelAgents = []"
                >
                  <v-radio
                    color="indigo darken-3"
                    :label="$t('ALL')"
                    value="ALL"
                  ></v-radio>
                  <v-radio
                    color="indigo darken-3"
                    :label="$t('TRAVEL_AGENT_SPEC')"
                    value="SPEC"
                  ></v-radio>
                </v-radio-group>
              </div>
            </div>
            <v-row class="align-center mt-0">
              <v-col sm="12" class="pb-0 pt-0">
                <v-autocomplete
                  item-text="label"
                  item-value="id"
                  :items="listAgent"
                  v-model="editedItem.travelAgents"
                  outlined
                  :disabled="travelAgentGeneral === 'ALL'"
                  chips
                  dense
                  multiple
                >
                  <template v-slot:prepend-item>
                    <p class="mx-3 mt-1">
                      <a
                        class="text-primary"
                        @click="
                          editedItem.travelAgents = listAgent.map((e) => e.id)
                        "
                        >{{ $t("SELECT_ALL") }}</a
                      >
                      |
                      <a
                        class="text-primary"
                        @click="editedItem.travelAgents = []"
                        >{{ $t("UN_SELECT_ALL") }}</a
                      >
                    </p>
                  </template>
                  <template v-slot:selection="{ item, index }">
                    <v-chip
                      color="primary"
                      v-if="index === 0 || index === 1"
                      v-bind="item.attrs"
                      :input-value="item.selected"
                      close
                      @click:close="removeChips(index, editedItem.travelAgents)"
                      @click="item.select"
                    >
                      <span>{{ item.label }}</span>
                    </v-chip>
                    <span v-if="index === 2" class="grey--text caption"
                      >(+{{ editedItem.travelAgents.length - 2 }})</span
                    >
                  </template>
                  <template slot="no-data">
                    <div class="no-data">{{ $t("NO_DATA") }}</div>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </div>
          <div class="w-50 pl-3">
            <div class="align-center d-flex mb-2">
              <div class="mr-3">
                <label class="label-title">{{ $t("MARKET_SEGMENT") }}</label>
              </div>
              <div>
                <v-radio-group
                  row
                  v-model="marketSegmentGeneral"
                  class="pl-2 pt-0 mt-0"
                  @change="editedItem.marketSegments = []"
                >
                  <v-radio
                    color="indigo darken-3"
                    :label="$t('ALL')"
                    value="ALL"
                  ></v-radio>
                  <v-radio
                    color="indigo darken-3"
                    :label="$t('SEGMENT_SPEC')"
                    value="SPEC"
                  ></v-radio>
                </v-radio-group>
              </div>
            </div>
            <v-row class="align-center mt-0">
              <v-col sm="12" class="pb-0 pt-0">
                <v-autocomplete
                  item-text="label"
                  item-value="id"
                  :items="marketSegments"
                  v-model="editedItem.marketSegments"
                  outlined
                  :disabled="marketSegmentGeneral === 'ALL'"
                  chips
                  dense
                  multiple
                >
                  <template v-slot:prepend-item>
                    <p class="mx-3 mt-1">
                      <a
                        class="text-primary"
                        @click="
                          editedItem.marketSegments = marketSegments.map(
                            (e) => e.id
                          )
                        "
                        >{{ $t("SELECT_ALL") }}</a
                      >
                      |
                      <a
                        class="text-primary"
                        @click="editedItem.marketSegments = []"
                        >{{ $t("UN_SELECT_ALL") }}</a
                      >
                    </p>
                  </template>
                  <template v-slot:selection="{ item, index }">
                    <v-chip
                      color="primary"
                      v-if="index === 0 || index === 1"
                      v-bind="item.attrs"
                      :input-value="item.selected"
                      close
                      @click:close="
                        removeChips(index, editedItem.marketSegments)
                      "
                      @click="item.select"
                    >
                      <span>{{ item.label }}</span>
                    </v-chip>
                    <span v-if="index === 2" class="grey--text caption"
                      >(+{{ editedItem.marketSegments.length - 2 }})</span
                    >
                  </template>
                  <template slot="no-data">
                    <div class="no-data">{{ $t("NO_DATA") }}</div>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </div>
        </div>
        <v-divider />

        <v-row>
          <v-col sm="6" cols="6">
            <label class="label-title">{{ $t("ASSIGN_HOTEL") }}</label>
            <v-row>
              <v-col>
                <v-card style="min-height: 350px">
                  <v-card-title class="fs-12 text-uppercase font-weight-bold">{{
                    $t("UNASSIGN")
                  }}</v-card-title>
                  <div class="pl-2 pr-2">
                    <v-text-field
                      prepend-inner-icon="mdi-magnify"
                      :placeholder="$t('HOTEL_NAME')"
                      v-model="searchUnApply"
                      @input="searchOnUnApply"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                  <v-list class="mt-2" flat subheader three-line>
                    <v-list-item-group
                      v-model="unApplySetting"
                      multiple
                      active-class="grey lighten-3"
                      style="max-height: 230px; overflow: auto"
                    >
                      <template v-for="(item, index) in searchedUnApply">
                        <v-list-item :key="index">
                          <template v-slot:default="{ active }">
                            <v-list-item-action>
                              <v-checkbox :input-value="active"></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title
                                v-text="item.name"
                                :class="!active ? 'text-secondary' : ''"
                              ></v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </v-list-item>
                      </template>
                    </v-list-item-group>
                  </v-list>
                </v-card>
                <p class="mb-0 mt-2">
                  {{ searchedUnApply.length }}/{{ unApplyHotel.length }}
                  {{ $t("ITEMS_SHOWING") }}
                </p>
              </v-col>
              <v-col sm="1" class="d-flex align-center justify-content-center">
                <div>
                  <v-btn class="d-block" @click="leftToRight">
                    <v-icon>navigate_next</v-icon>
                  </v-btn>
                  <v-btn class="d-block mt-3" @click="rightToLeft">
                    <v-icon>chevron_left</v-icon>
                  </v-btn>
                  <v-btn class="d-block mt-3" @click="allLeftToRight">
                    <v-icon>keyboard_double_arrow_right</v-icon>
                  </v-btn>
                  <v-btn class="d-block mt-3" @click="allRightToLeft">
                    <v-icon>keyboard_double_arrow_left</v-icon>
                  </v-btn>
                  <v-btn class="d-block mt-3" @click="compare">
                    <v-icon>compare_arrows</v-icon>
                  </v-btn>
                </div>
              </v-col>
              <v-col>
                <v-card style="min-height: 350px">
                  <v-card-title class="fs-12 text-uppercase font-weight-bold">{{
                    $t("ASSIGN")
                  }}</v-card-title>
                  <div class="pl-2 pr-2">
                    <v-text-field
                      prepend-inner-icon="mdi-magnify"
                      :placeholder="$t('HOTEL_NAME')"
                      v-model="searchApply"
                      @input="searchOnApply"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                  <v-list class="mt-2" flat subheader three-line>
                    <v-list-item-group
                      v-model="applySetting"
                      multiple
                      active-class="grey lighten-3"
                      style="max-height: 230px; overflow: auto"
                    >
                      <template v-for="(item, index) in searchedApply">
                        <v-list-item>
                          <template v-slot:default="{ active }">
                            <v-list-item-action>
                              <v-checkbox :input-value="active"></v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <v-list-item-title
                                v-text="item.name"
                                :class="!active ? 'text-secondary' : ''"
                              ></v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </v-list-item>
                      </template>
                    </v-list-item-group>
                  </v-list>
                </v-card>
                <p class="mb-0 mt-2">
                  {{ searchedApply.length }}/{{ applyHotel.length }}
                  {{ $t("ITEMS_SHOWING") }}
                </p>
              </v-col>
            </v-row>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col sm="6" cols="6">
            <!-- <label class="label-title">{{ $t("ASSIGN_OTA") }}</label>
            <v-row>
              <v-col>
                <v-card style="min-height: 350px">
                  <v-card-title class="fs-12 text-uppercase">{{ $t("UNASSIGN") }}</v-card-title>
                  <v-list flat subheader style="max-height: 230px; overflow: auto">
                    <template v-for="( item, index ) in hotelOtaAssign">
                      <v-list-item :key="index" v-if="item.unOtas.length > 0">
                        <v-list-item-content class="pt-0">
                          <v-list-item-title class="font-weight-bold"
                            v-text="hotelchain.find(e => e.id === item.hotelId).name"></v-list-item-title>
                          <ul class="mb-0">
                            <li v-for="(ota, indOta) in item.unOtas" style="list-style-type: decimal; line-height: 1.5">
                              {{ ota.i18ns.find((x) => x.lang == sysLang).name }}
                            </li>
                          </ul>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-card>
              </v-col>
              <v-col>
                <v-card style="min-height: 350px">
                  <v-card-title class="fs-12 text-uppercase">{{ $t("ASSIGN") }}</v-card-title>
                  <v-list flat subheader style="max-height: 230px; overflow: auto">
                    <template v-for="( item, index ) in hotelOtaAssign">
                      <v-list-item :key="index" v-if="item.otas.length > 0">
                        <v-list-item-content class="pt-0">
                          <v-list-item-title class="font-weight-bold"
                            v-text="hotelchain.find(e => e.id === item.hotelId).name"></v-list-item-title>
                          <ul class="mb-0">
                            <li v-for="(ota, indOta) in item.otas" style="list-style-type: decimal; line-height: 1.5">
                              {{ ota.i18ns.find((x) => x.lang == sysLang).name }}
                            </li>
                          </ul>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
            <p class="mb-0 text-success">
              {{ $t('NOTE_ASIGN_OTA') }}
            </p> -->
            <label class="label-title">{{ $t("ASSIGN_ROOM_TYPE") }}</label>
            <v-row>
              <v-col>
                <v-card>
                  <v-card-title class="fs-12 text-uppercase font-weight-bold">{{
                    $t("UNASSIGN")
                  }}</v-card-title>
                  <div class="pl-2 pr-2">
                    <v-text-field
                      prepend-inner-icon="mdi-magnify"
                      :placeholder="$t('_BOOKING.SEARCH')"
                      v-model="searchUnApplyMap"
                      @input="searchOnUnApply"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                  <div style="height: 247px; overflow-y: auto" class="p-2">
                    <v-treeview
                      v-model="selectUnmap"
                      :search="searchUnApplyMap"
                      :filter="filter"
                      selectable
                      selected-color="primary"
                      :items="roomMap"
                      open-on-click
                      selection-type="leaf"
                    ></v-treeview>
                  </div>
                </v-card>
              </v-col>
              <v-col sm="1" class="d-flex align-center justify-content-center">
                <div>
                  <v-btn class="d-block" @click="leftToRightMap">
                    <v-icon>navigate_next</v-icon>
                  </v-btn>
                  <v-btn class="d-block mt-3" @click="rightToLeftMap">
                    <v-icon>chevron_left</v-icon>
                  </v-btn>
                  <v-btn class="d-block mt-3" @click="allLeftToRightMap">
                    <v-icon>keyboard_double_arrow_right</v-icon>
                  </v-btn>
                  <v-btn class="d-block mt-3" @click="allRightToLeftMap">
                    <v-icon>keyboard_double_arrow_left</v-icon>
                  </v-btn>
                  <v-btn class="d-block mt-3" @click="compareMap">
                    <v-icon>compare_arrows</v-icon>
                  </v-btn>
                </div>
              </v-col>
              <v-col>
                <v-card>
                  <v-card-title class="fs-12 text-uppercase font-weight-bold">{{
                    $t("ASSIGN")
                  }}</v-card-title>
                  <div class="pl-2 pr-2">
                    <v-text-field
                      prepend-inner-icon="mdi-magnify"
                      :placeholder="$t('_BOOKING.SEARCH')"
                      v-model="searchApplyMap"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                  <div style="height: 247px; overflow-y: auto" class="p-2">
                    <v-treeview
                      v-model="selectMap"
                      :search="searchApplyMap"
                      :filter="filter"
                      selectable
                      selected-color="primary"
                      :items="roomsMaped"
                      open-on-click
                      selection-type="leaf"
                      item-disabled="locked"
                    ></v-treeview>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <b-row>
          <v-col>
            <v-checkbox
              v-model="editedItem.overwrite"
              :label="$t('ALLOW_OVERWRITING_INFOMATION_DOWN_TO_THE_HOTEL')"
              class="mt-0"
            ></v-checkbox>
          </v-col>
          <v-col>
            <div class="btn-bottom">
              <v-btn depressed class="mr-5" @click="back">
                {{ $t("BACK") }}
              </v-btn>
              <v-btn
                color="primary"
                class="pr-10 pl-10"
                @click="editedItem.id ? confirmSave() : save(false)"
                :disabled="disableSaveBtn"
                >{{ $t("SAVE") }}</v-btn
              >
            </div>
          </v-col>
        </b-row>
      </div>
      <v-dialog v-model="dialogConfirmSave" persistent max-width="390">
        <v-toolbar class="toolbar-update" dense>
          <v-toolbar-title class="text-primary fs-15">
            <strong>{{ $t("NOTIFICATION") }}</strong>
          </v-toolbar-title>
        </v-toolbar>
        <div class="content-update">
          <label class="s-label">{{ $t("DIALOG_CONFIRM_DESC") }}</label>
          <div class="mt-3 d-flex justify-content-between">
            <div class="w-100 mr-1">
              <v-btn
                depressed
                block
                @click="
                  dialogConfirmSave = false;
                  save(false);
                "
              >
                {{ $t("NO") }}
              </v-btn>
            </div>
            <div class="w-100 ml-1">
              <v-btn
                block
                color="primary"
                @click="
                  dialogConfirmSave = false;
                  save(true);
                "
              >
                {{ $t("YES") }}
              </v-btn>
            </div>
          </div>
        </div>
      </v-dialog>
    </v-form>
  </div>
</template>

<style lang="scss" scoped>
.subtitle {
  text-transform: uppercase;
  font-size: 15px;
}

.code input {
  text-transform: uppercase;
}

.invalid-text {
  color: red;
  margin-top: -15px;
  position: absolute;
}

.item-cancel-policy {
  border: 1px dashed #cdcdcd;
  padding: 10px;

  p {
    margin-bottom: 0;
  }
}

.item-payment-policy {
  border: 1px dashed #cdcdcd;
  padding: 10px;

  p {
    margin-bottom: 0;
  }
}

.current-cancellation {
  background: linear-gradient(
      0deg,
      rgba(0, 62, 148, 0.1),
      rgba(0, 62, 148, 0.1)
    ),
    #ffffff;
  padding: 0 10px;
  margin-bottom: 10px;
  border-radius: 5px;

  p {
    margin-bottom: 0;
  }
}
</style>
<script>
const toLower = (text) => {
  return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
  if (term) {
    return items.filter((item) => toLower(item.name).includes(toLower(term)));
  }

  return items;
};
import store from "@/plugins/store";
import DatePicker from "@/components/Utils/DatePicker.vue";
import { salePackageService } from "@/_services/SaleRoom/sale-package.service.js";
import { service } from "@/_services/RoomInfomation/list-of-rooms.service.js";
import { ChainCategoryService } from "@/_services/ChainManage/category.service.js";
import { chainService } from "@/_services/ChainManage/chain.service.js";

import { _alert, _formatCurrency } from "@/_helpers/function.js";
import { DAYS_OF_WEEK, SPD_ERROR } from "@/_helpers/config.js";

import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import TinycmeEditor from "@/components/Utils/tinymce.vue";

export default {
  components: {
    "date-picker": DatePicker,
    Treeselect,
    TinycmeEditor,
  },
  created() {
    this.getAllRooms();
  },
  data() {
    return {
      panel: [0, 1],
      disableSaveBtn: false,
      currency: this.usedCurrency,
      isLoading: false,
      editedItem: null,
      tab: null,
      sysLang: this.$i18n.locale,
      lang: "vi",
      select: {
        child: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
        baby: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        meals: [],
        paymentPolicy: [],
        cancelPolicy: [],
        applyFor: [],
        cardApply: [],
      },
      errors: SPD_ERROR,
      error: {
        startDate: {
          error: null,
          message: this.$t("_REGISTER.REQUIRED_FIELD"),
          required: null,
        },
        endDate: {
          error: null,
          message: this.$t("_REGISTER.REQUIRED_FIELD"),
          required: null,
        },
      },
      listMeal: [],
      isEmptyDefaultTitle: false,
      listOfChannels: [],
      selectAllChannel: false,
      listOfMarkets: [],
      selectAllMarket: false,
      notApplyDates: [],
      applyAllChannel: "ALL",
      applyAllMarket: "ALL",
      daysOfWeek: DAYS_OF_WEEK,
      weekend: [],
      defaultWeekend: [],
      ruleNotEmpty: [(v) => !!v || this.$t("NOT_EMPTY")],
      rateCancellationsAddIds: [],
      ratePaymentsAddIds: [],
      dialogCancelPolicy: false,
      dialogPaymentPolicy: false,
      isDisableSalePackageCode: false,
      isConfirmSave: false,
      dialogConfirmSave: false,
      clone: {
        editedItem: {
          ratePayments: [],
        },
      },
      isAddNew: true,

      hotelchain: [],
      applyHotel: [],
      unApplyHotel: [],
      searchApply: null,
      searchedApply: [],
      searchedUnApply: [],
      listRooms: [],
      hotelOtaAssign: [],
      listCategory: [],
      marketSegments: [],
      listAgent: [],
      travelAgentGeneral: "ALL",
      marketSegmentGeneral: "ALL",

      rooms: [],
      roomRateRoot: [],
      otas: [],
      searchUnApplyMap: null,
      searchApplyMap: null,
      selectUnmap: [],
      selectMap: [],
      roomsMaped: [],
      roomMap: [],
    };
  },
  computed: {
    likesAllRateParties() {
      return this.editedItem.rateParties.length === this.select.applyFor.length;
    },
    likesSomeRateParties() {
      return this.editedItem.rateParties.length > 0 && !this.select.applyFor;
    },
    iconObject() {
      if (this.likesAllRateParties) return "mdi-close-box";
      if (this.likesSomeRateParties) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    likesAllCard() {
      return this.editedItem.rateCards.length === this.select.cardApply.length;
    },
    likesSomeCard() {
      return this.editedItem.rateCards.length > 0 && !this.select.cardApply;
    },
    iconCard() {
      if (this.likesAllCard) return "mdi-close-box";
      if (this.likesSomeCard) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    likesAllMeal() {
      // this.select.meals.forEach(x => {
      //   this.editedItem.lstMealId.push(x.value);
      // });

      return this.editedItem.lstMealId.length === this.select.meals.length;

      // return this.editedItem.lstMealId;
    },
    likesSomeMeal() {
      return this.editedItem.lstMealId.length > 0 && !this.select.meals;
    },
    iconMeal() {
      if (this.likesAllMeal) return "mdi-close-box";
      if (this.likesSomeMeal) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  watch: {
    tab(value) {
      this.lang = value ? "en" : "vi";
    },
    lang(value) {
      this.editorData = this.editedItem.i18ns.find(
        (x) => x.lang == value
      ).description;
    },
    editedItem: {
      handler(value) {},
      deep: true,
    },
    weekend(value) {
      let tmp = [0, 0, 0, 0, 0, 0, 0];
      value.forEach(function (element) {
        if (element === "MON") {
          tmp[0] = 1;
        }

        if (element === "TUE") {
          tmp[1] = 1;
        }

        if (element === "WED") {
          tmp[2] = 1;
        }

        if (element === "THU") {
          tmp[3] = 1;
        }

        if (element === "FRI") {
          tmp[4] = 1;
        }

        if (element === "SAT") {
          tmp[5] = 1;
        }

        if (element === "SUN") {
          tmp[6] = 1;
        }
      });

      this.editedItem.bitWeekDays = parseInt(tmp.join(""), 2);
    },
  },
  mounted() {},
  methods: {
    allLeftToRightMap() {
      this.selectUnmap = [];
      this.roomMap.forEach((r) => {
        r.children.forEach((ota) => {
          this.selectUnmap.push(ota.id);
        });
      });
      this.leftToRightMap();
    },
    allRightToLeftMap() {
      this.selectMap = [];
      this.roomsMaped.forEach((r) => {
        r.children.forEach((ota) => {
          this.selectMap.push(ota.id);
        });
      });
      this.rightToLeftMap();
    },
    compareMap() {
      this.selectUnmap = [];
      this.selectMap = [];
      const unApply = Array.from(new Set(this.roomMap.map(JSON.stringify))).map(
        JSON.parse
      );
      unApply.forEach((r) => {
        r.children.forEach((ota) => {
          this.selectUnmap.push(ota.id);
        });
      });
      const apply = Array.from(
        new Set(this.roomsMaped.map(JSON.stringify))
      ).map(JSON.parse);
      apply.forEach((r) => {
        r.children.forEach((ota) => {
          this.selectMap.push(ota.id);
        });
      });
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.leftToRightMap();
        setTimeout(() => {
          this.rightToLeftMap();
        }, 100);
      }, 500);
    },
    leftToRightMap() {
      this.roomMap.slice(
        this.roomMap.findIndex((r) => r.children.length === 0),
        1
      );
      this.selectUnmap.forEach((item) => {
        let roomId = item.split("|")[0];
        let otaId = item.split("|")[1];
        if (!otaId) return;
        if (this.roomsMaped.find((r) => r.id === roomId)) {
          this.roomsMaped
            .find((r) => r.id === roomId)
            .children.push({
              id: item,
              otaId: otaId,
              name: this.otas.find((e) => e.id == otaId)
                ? this.otas.find((e) => e.id == otaId).name
                : null,
              connectedOTA: -1,
              locked: false,
            });
        } else {
          this.roomsMaped.push({
            id: roomId,
            name: this.rooms.find((e) => e.id == roomId)
              ? this.rooms.find((e) => e.id == roomId).name
              : null,
            children: [
              {
                id: item,
                otaId: otaId,
                name: this.otas.find((e) => e.id == otaId)
                  ? this.otas.find((e) => e.id == otaId).name
                  : null,
                connectedOTA: -1,
                locked: false,
              },
            ],
          });
        }
      });
      this.selectUnmap = [];
      this.$forceUpdate();
      setTimeout(() => {
        this.roomsMaped.forEach((prod) => {
          this.roomMap.forEach((map) => {
            if (map.id === prod.id) {
              prod.children.forEach((ota) => {
                if (
                  map.children.findIndex((item) => item.id === ota.id) != -1
                ) {
                  map.children.splice(
                    map.children.findIndex((item) => item.id === ota.id),
                    1
                  );
                  this.$forceUpdate();
                }
              });
            }
          });
        });
        this.roomMap = this.roomMap.filter((room) => room.children.length > 0);
      }, 100);
    },
    rightToLeftMap() {
      if (this.selectMap.length === 0) return;
      this.selectMap.forEach((item) => {
        let roomId = item.split("|")[0];
        let otaId = item.split("|")[1];
        if (!otaId) return;
        if (this.roomMap.find((r) => r.id === roomId)) {
          this.roomMap
            .find((r) => r.id === roomId)
            .children.push({
              id: item,
              otaId: otaId,
              name: this.otas.find((e) => e.id == otaId)
                ? this.otas.find((e) => e.id == otaId).name
                : null,
              connectedOTA: -2,
              locked: false,
            });
        } else {
          this.roomMap.push({
            id: roomId,
            name: this.rooms.find((e) => e.id == roomId)
              ? this.rooms.find((e) => e.id == roomId).name
              : null,
            children: [
              {
                id: item,
                otaId: otaId,
                name: this.otas.find((e) => e.id == otaId)
                  ? this.otas.find((e) => e.id == otaId).name
                  : null,
                connectedOTA: -2,
                locked: false,
              },
            ],
          });
        }
      });

      setTimeout(() => {
        this.roomMap.forEach((prod) => {
          this.roomsMaped.forEach((map) => {
            if (map.id === prod.id) {
              prod.children.forEach((ota) => {
                if (
                  map.children.findIndex((item) => item.id === ota.id) != -1
                ) {
                  map.children.splice(
                    map.children.findIndex((item) => item.id === ota.id),
                    1
                  );
                  this.$forceUpdate();
                }
              });
            }
          });
        });
        this.roomsMaped = this.roomsMaped.filter(
          (room) => room.children.length > 0
        );
      }, 100);
      this.selectMap = [];
      this.$forceUpdate();
    },

    getAllTravelAgent() {
      this.listAgent = [];
      let body = {};
      body.keyword = "";
      body.status = null;
      body.limit = 9999999;
      body.offset = 0;
      body.orderBy = "active";
      body.asc = false;

      chainService
        .getAllTravelAgent(body)
        .then((res) => {
          this.listAgent = res.data.map((e) =>
            Object.assign(
              {},
              {
                id: e.id,
                label: !e.active
                  ? e.title + ` (${this.$t("DEACTIVE")})`
                  : e.title,
                disabled: !e.active,
              }
            )
          );
        })
        .finally(() => this.getAllSegment());
    },
    getAllSegment() {
      this.marketSegments = [];

      chainService
        .getAllSegment()
        .then((res) => {
          this.marketSegments = res.data.map((e) =>
            Object.assign(
              {},
              {
                id: e.id,
                label:
                  e.active != 1 ? e.name + ` (${this.$t("DEACTIVE")})` : e.name,
                disabled: e.active != 1,
              }
            )
          );
        })
        .finally(() => {
          this.getHotelByChain();
        });
    },
    getAllRooms() {
      this.isLoading = true;
      let body = {};
      body.keyword = "";
      body.status = 1;
      body.limit = 99999;
      body.offset = 0;
      body.orderBy = "active";
      body.asc = false;
      chainService
        .getAllRooms(body)
        .then((res) => {
          this.listRooms = res.data.map((x) => {
            return {
              value: x.roomId,
              text: x.i18ns.find((y) => y.lang == this.defaultI18n).name,
            };
          });
          this.rooms = res.data.map((x) => {
            return {
              id: x.roomId,
              name: x.i18ns.find((y) => y.lang == this.defaultI18n).name,
            };
          });
          this.roomMap = res.data.map((x) => {
            return {
              id: x.roomId,
              name: x.i18ns.find((y) => y.lang == this.defaultI18n).name,
              children: [],
            };
          });
        })
        .finally(() => this.getAllCategory());
    },
    clearSearch() {
      this.searchApply = null;
      this.searchUnApply = null;
      this.searchOnApply();
      this.searchOnUnApply();
    },
    searchOnApply() {
      this.searchedApply = searchByName(this.applyHotel, this.searchApply);
    },
    searchOnUnApply() {
      this.searchedUnApply = searchByName(
        this.unApplyHotel,
        this.searchUnApply
      );
    },
    leftToRight() {
      if (this.unApplySetting.length > 0) {
        this.unApplySetting.forEach((e) => {
          this.applyHotel.push(this.searchedUnApply[e]);
        });
        this.unApplyHotel = this.hotelchain.filter(
          (e) => !this.applyHotel.map((e) => e.id).includes(e.id)
        );
        this.applySetting = [];
        this.unApplySetting = [];
        this.clearSearch();
      }
    },

    rightToLeft() {
      if (this.applySetting.length > 0) {
        this.applySetting.forEach((e) => {
          this.unApplyHotel.push(this.searchedApply[e]);
        });
        this.applyHotel = this.hotelchain.filter(
          (e) => !this.unApplyHotel.map((e) => e.id).includes(e.id)
        );
        this.applySetting = [];
        this.unApplySetting = [];
        this.clearSearch();
      }
    },
    allLeftToRight() {
      if (this.searchedUnApply.length > 0) {
        this.searchedUnApply.forEach((e) => {
          this.applyHotel.push(e);
        });
        this.unApplyHotel = this.hotelchain.filter(
          (e) => !this.applyHotel.map((e) => e.id).includes(e.id)
        );
        this.searchedUnApply = [];
        this.applySetting = [];
        this.unApplySetting = [];
        this.clearSearch();
      }
    },
    allRightToLeft() {
      if (this.searchedApply.length > 0) {
        this.searchedApply.forEach((e) => {
          this.unApplyHotel.push(e);
        });
        this.applyHotel = this.hotelchain.filter(
          (e) => !this.unApplyHotel.map((e) => e.id).includes(e.id)
        );
        this.searchedApply = [];
        this.applySetting = [];
        this.unApplySetting = [];
        this.clearSearch();
      }
    },
    compare() {
      const apply = Array.from(
        new Set(this.applyHotel.map(JSON.stringify))
      ).map(JSON.parse);
      const unApply = Array.from(
        new Set(this.unApplyHotel.map(JSON.stringify))
      ).map(JSON.parse);
      this.applyHotel = [...unApply];
      this.unApplyHotel = [...apply];
      this.applySetting = [];
      this.unApplySetting = [];
      this.clearSearch();
    },
    async getHotelByChain() {
      await chainService.getHotelByChain(this.defaultI18n).then((res) => {
        if (res.responseCode == 0) {
          this.hotelchain = res.data;
          let body = this.hotelchain.map((e) => e.id);
          this.getAllOtaChain();
        }
      });
    },
    getAllOtaChain() {
      chainService
        .getAllOtaByChain()
        .then((res) => {
          this.otas = res.data.map((x) => {
            return {
              id: x.id,
              name: x.i18ns.find((y) => y.lang == this.defaultI18n).name,
            };
          });
          this.roomMap.forEach((r) => {
            r.children = this.otas.map((o) =>
              Object.assign(
                {},
                {
                  id: r.id + "|" + o.id,
                  otaId: o.id,
                  name: o.name,
                  connectedOTA: -1,
                  locked: false,
                }
              )
            );
          });
        })
        .finally(() => this.initialize());
    },
    async getOtaAssign(data) {
      const body = {
        hotelIds: [...data],
        chainRatePlanId: this.$route.params.id,
      };
      await chainService.getOtaAssign(body).then((res) => {
        if (res.responseCode == 0) {
          this.hotelOtaAssign = res.data.map((e) => {
            return Object.assign(e, { unOtas: [] });
          });
          this.getAllOtaAssign(body);
        }
      });
    },
    async getAllOtaAssign(data) {
      await chainService
        .getAllOtaAssign(data)
        .then((res) => {
          if (res.responseCode == 0) {
            this.hotelOtaAssign.forEach((h) => {
              res.data.forEach((e) => {
                if (h.otas.filter((o) => o.id === e.id).length === 0) {
                  h.unOtas.push(e);
                }
              });
            });
            this.otas = res.data.map((x) => {
              return {
                id: x.id,
                name: x.i18ns.find((y) => y.lang == this.defaultI18n).name,
              };
            });
            this.roomMap.forEach((r) => {
              r.children = this.otas.map((o) =>
                Object.assign(
                  {},
                  {
                    id: r.id + "|" + o.id,
                    otaId: o.id,
                    name: o.name,
                    connectedOTA: -1,
                    locked: false,
                  }
                )
              );
            });
          }
        })
        .finally(() => this.initialize());
    },
    confirmSave() {
      if (this.isConfirmSave) {
        if (!this.editedItem.startDate && this.editedItem.session) {
          this.error.startDate.error = true;
        } else {
          this.error.startDate.error = false;
        }

        if (!this.editedItem.endDate && this.editedItem.session) {
          this.error.endDate.error = true;
        } else {
          this.error.endDate.error = false;
        }
        if (this.error.endDate.error || this.error.startDate.error) {
          store.commit("alert/display", {
            message: this.$t("_VALIDATE.REQUIRED"),
            error: true,
            success: false,
          });
          const el = document.querySelector(
            ".v-messages.error--text:first-of-type"
          );
          el.scrollIntoView();
          return false;
        }
        this.dialogConfirmSave = true;
      } else {
        this.save(false);
      }
    },
    toggleObject() {
      this.$nextTick(() => {
        if (this.likesAllRateParties) {
          this.editedItem.rateParties = [];
        } else {
          // this.editedItem.rateParties = this.select.applyFor.slice();
          this.select.applyFor.forEach((x) => {
            this.editedItem.rateParties.push(x.value);
          });
        }
      });
    },
    toggleCard() {
      this.$nextTick(() => {
        if (this.likesAllCard) {
          this.editedItem.rateCards = [];
        } else {
          // this.editedItem.rateCards = this.select.cardApply.slice();
          this.select.cardApply.forEach((x) => {
            this.editedItem.rateCards.push(x.value);
          });
        }
      });
    },
    toggleMeal() {
      this.$nextTick(() => {
        if (this.likesAllMeal) {
          this.editedItem.lstMealId = [];
        } else {
          this.editedItem.lstMealId = [];
          this.select.meals.forEach((x) => {
            this.editedItem.lstMealId.push(x.value);
          });
          // this.editedItem.lstMealId = this.select.meals.slice();
        }
      });
    },
    async initialize() {
      this.isLoading = true;

      let id = this.$route.params.id;
      if (id != 0) {
        this.isAddNew = false;
        await chainService.getRatePlanDetail(id).then((res) => {
          this.editedItem = res.data;
          this.editedItem.mappedRoomRates.forEach((prod) => {
            if (this.roomMap.find((r) => r.id === prod.roomTypeId)) {
              this.roomMap
                .find((r) => r.id === prod.roomTypeId)
                .children.splice(
                  this.roomMap
                    .find((r) => r.id === prod.roomTypeId)
                    .children.findIndex((item) => item.otaId === prod.otaId),
                  1
                );
            }
          });
          this.roomMap = this.roomMap.filter(
            (room) => room.children.length > 0
          );
          const arrGroupProd = Object.values(
            this.editedItem.mappedRoomRates.reduce((acc, obj) => {
              const key = obj.roomTypeId;
              acc[key] = acc[key] || { roomTypeId: key, items: [] };
              acc[key].items.push(obj);
              return acc;
            }, {})
          );
          this.roomsMaped = [];
          arrGroupProd.forEach((item) => {
            this.roomsMaped.push({
              id: item.roomTypeId,
              name: this.rooms.find((e) => e.id == item.roomTypeId).name,
              children: item.items.map((o) =>
                Object.assign(
                  {},
                  {
                    id: item.roomTypeId + "|" + o.otaId,
                    otaId: o.otaId,
                    name: this.otas.find((e) => e.id == o.otaId).name,
                    connectedOTA: o.connectedOTA,
                    locked: o.connectedOTA === 1 ? true : false,
                  }
                )
              ),
            });
          });
          if (
            this.editedItem.travelAgents.includes(
              "00000000-0000-0000-0000-000000000000"
            )
          ) {
            this.travelAgentGeneral = "ALL";
          } else {
            this.travelAgentGeneral = "SPEC";
          }

          if (
            this.editedItem.marketSegments.includes(
              "00000000-0000-0000-0000-000000000000"
            )
          ) {
            this.marketSegmentGeneral = "ALL";
          } else {
            this.marketSegmentGeneral = "SPEC";
          }

          // Chuyển từ binary sang select
          this.defaultWeekend = this.convertFromBinaryToListSelection(
            res.data.bitWeekDays
          );
          var tmp = [];
          this.defaultWeekend.forEach(function (element, index) {
            if (element == 1) {
              if (index == 0) {
                tmp.push("MON");
              }
              if (index == 1) {
                tmp.push("TUE");
              }
              if (index == 2) {
                tmp.push("WED");
              }
              if (index == 3) {
                tmp.push("THU");
              }
              if (index == 4) {
                tmp.push("FRI");
              }
              if (index == 5) {
                tmp.push("SAT");
              }
              if (index == 6) {
                tmp.push("SUN");
              }
            }
          });
          this.weekend = tmp;

          if (res.data.markets == null) {
            this.applyAllMarket = "ALL";
          } else {
            this.applyAllMarket = "NOT_ALL";
          }
          if (res.data.channels == null) {
            this.applyAllChannel = "ALL";
          } else {
            this.applyAllChannel = "NOT_ALL";
          }

          if (res.data.ratePlanCode) {
            this.isDisableSalePackageCode = true;
          }

          // this.clone.editedItem.ratePayments = [
          //   ...this.editedItem.ratePayments
          // ];
          // this.clone.editedItem.rateCancellations = [
          //   ...this.editedItem.rateCancellations
          // ];
        });
      } else {
        this.isAddNew = true;
        this.weekend = ["WED", "THU", "FRI", "SAT", "SUN", "TUE", "MON"];
        this.clone.editedItem.ratePayments = [];
        this.clone.editedItem.rateCancellations = [];
        this.editedItem = {
          status: true,
          ageMaxBaby: 0,
          ageMaxChild: 0,
          bitWeekDays: 179,
          cancellationRulesVi: null,
          channels: null,
          descriptionVi: null,
          endDate: null,
          forPromoCode: null,
          i18ns: [
            {
              cancellationRules: "cancel",
              description: "",
              lang: "vi",
              name: "",
            },
            {
              cancellationRules: "cancel",
              description: "",
              lang: "en",
              name: "",
            },
          ],
          id: null,
          includedTax: false,
          lstMealId: [],
          markets: [],
          nameVi: "",
          needCvv: false,
          parentId: null,
          rateBlackouts: [],
          rateCancellations: [],
          rateCards: [],
          rateLevel: 0,
          rateParties: [],
          ratePaymentTypes: [],
          ratePayments: [],
          ratePlanCode: "",
          session: false,
          startDate: null,
          warrantyType: 0,
          applyHotels: [],
          roomTypeIds: [],
          rateCategoryId: null,
          travelAgents: [],
          marketSegments: [],
        };
      }
      if (this.editedItem.applyHotels.length > 0) {
        this.applyHotel = this.hotelchain.filter((e) =>
          this.editedItem.applyHotels.includes(e.id)
        );
        this.unApplyHotel = this.hotelchain.filter(
          (e) => !this.editedItem.applyHotels.includes(e.id)
        );

        this.searchedApply = this.hotelchain.filter((e) =>
          this.editedItem.applyHotels.includes(e.id)
        );
        this.searchedUnApply = this.hotelchain.filter(
          (e) => !this.editedItem.applyHotels.includes(e.id)
        );
      } else {
        this.unApplyHotel = [...this.hotelchain];
        this.clearSearch();
      }

      await salePackageService.getMeal().then((res) => {
        this.select.meals = res.data.map((x) => {
          return {
            value: x.id,
            text: x.lookupItemI18n.find((y) => y.lang == this.defaultI18n).name,
          };
        });
        this.select.meals = this.select.meals.filter((x) => x.value);
      });

      let body = {
        limit: 15,
        offset: 0,
      };
      // this.getAllRooms()
      this.isLoading = false;
    },
    getAllCategory() {
      let body = {};
      body.keyword = "";
      body.limit = 9999;
      body.offset = 0;
      body.orderBy = "active";
      body.asc = false;
      ChainCategoryService.getRateCategoryList(body)
        .then((res) => {
          this.listCategory = res.data.map((x) => {
            return {
              value: x.id,
              text: x.i18ns.find((y) => y.lang == this.defaultI18n).name,
            };
          });
        })
        .finally(() => this.getAllTravelAgent());
    },
    convertFromBinaryToListSelection(number) {
      let output = parseInt(number, 10).toString(2);
      while (output.length < 7) {
        output = "0" + output;
      }
      return output.split("");
    },
    updateRoomTitle(value) {
      if (value.length > 0) {
        this.isEmptyDefaultTitle = false;
        for (let i = 0; i < this.editedItem.i18ns.length; i++) {
          this.editedItem.i18ns[i].name = value;
        }
      } else {
        this.isEmptyDefaultTitle = true;
      }
    },
    updateRoomDescription(value) {
      for (let i = 0; i < this.editedItem.i18ns.length; i++) {
        this.editedItem.i18ns[i].description = value;
      }
    },
    updateRoomBenefit(value) {
      for (let i = 0; i < this.editedItem.i18ns.length; i++) {
        this.editedItem.i18ns[i].benefit = value;
      }
    },
    applyAllMarketStatus() {
      if (this.applyAllMarket === "NOT_ALL") {
        this.editedItem.markets = null;
        this.selectAllMarket = false;
      } else {
        this.editedItem.markets = [];
      }
    },
    applyAllChannelStatus() {
      if (this.applyAllChannel === "NOT_ALL") {
        this.editedItem.channels = null;
        this.selectAllChannel = false;
      } else {
        this.editedItem.channels = [];
      }
    },
    clickSelectAllChannel() {
      if (this.selectAllChannel) {
        this.listOfChannels.forEach((e) => {
          this.editedItem.channels.push(e.id);
        });
      } else {
        this.editedItem.channels = [];
      }
    },
    clickSelectAllMarket() {
      if (this.selectAllMarket) {
        this.listOfMarkets.forEach((e) => {
          this.editedItem.markets.push(e.id);
        });
      } else {
        this.editedItem.markets = [];
      }
    },
    validate() {},
    save(replaceOldRestriction) {
      let form_validate = this.$refs.form.validate();
      if (!this.editedItem.startDate && this.editedItem.session) {
        this.error.startDate.error = true;
      } else {
        this.error.startDate.error = false;
      }

      if (!this.editedItem.endDate && this.editedItem.session) {
        this.error.endDate.error = true;
      } else {
        this.error.endDate.error = false;
      }

      if (
        !form_validate ||
        this.error.endDate.error ||
        this.error.startDate.error
      ) {
        store.commit("alert/display", {
          message: this.$t("_VALIDATE.REQUIRED"),
          error: true,
          success: false,
        });
        this.$nextTick(() => {
            const el = document.querySelector(".v-messages.error--text");
            if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        });
        return false;
      }

      if (form_validate) {
        this.editedItem.rateBlackouts = this.editedItem.rateBlackouts.filter(
          (x) => x.startDate && x.endDate
        );
        this.editedItem.travelAgents =
          this.travelAgentGeneral === "ALL"
            ? ["00000000-0000-0000-0000-000000000000"]
            : this.editedItem.travelAgents;
        this.editedItem.marketSegments =
          this.marketSegmentGeneral === "ALL"
            ? ["00000000-0000-0000-0000-000000000000"]
            : this.editedItem.marketSegments;

        this.editedItem.createRoomRates = [];
        this.editedItem.deleteRoomRates = [];
        let createRoomRates = [];
        let deleteRoomRates = [];
        this.roomsMaped.forEach((e) => {
          e.children.forEach((ota) => {
            if (ota.connectedOTA === -1) {
              createRoomRates.push({
                roomTypeId: e.id,
                otaId: ota.otaId,
              });
            }
          });
        });
        this.roomMap.forEach((e) => {
          e.children.forEach((ota) => {
            if (ota.connectedOTA === -2) {
              deleteRoomRates.push({
                roomTypeId: e.id,
                otaId: ota.otaId,
              });
            }
          });
        });

        if (this.editedItem.mappedRoomRates) {
          this.editedItem.mappedRoomRates.forEach((rr) => {
            createRoomRates.forEach((e) => {
              if (e.otaId === rr.otaId && e.roomTypeId === rr.roomTypeId) {
                e.remove = true;
              }
            });
          });
          this.editedItem.createRoomRates = createRoomRates.filter(
            (e) => !e.remove
          );
          this.editedItem.createRoomRates.forEach((e) => {
            delete e.remove;
          });
          this.editedItem.mappedRoomRates.forEach((rr) => {
            deleteRoomRates.forEach((item) => {
              if (item.otaId == rr.otaId && item.roomTypeId == rr.roomTypeId) {
                this.editedItem.deleteRoomRates.push(item);
              }
            });
          });
        } else {
          this.editedItem.createRoomRates = [...createRoomRates];
          this.editedItem.deleteRoomRates = [];
        }

        let updatedData = Object.assign({}, this.editedItem);
        updatedData.applyHotels = this.applyHotel
          .filter((e) => this.editedItem.applyHotels.includes(e.id))
          .map((item) => item.id);
        updatedData.unApplyHotels = this.editedItem.applyHotels.filter(
          (e) => !this.applyHotel.map((item) => item.id).includes(e)
        );
        updatedData.createApplyHotels = this.applyHotel
          .filter((e) => !this.editedItem.applyHotels.includes(e.id))
          .map((item) => item.id);

        if (this.editedItem.id) {
          this.disableSaveBtn = true;
          chainService.updateRate(updatedData).then((res) => {
            _alert(res, this.$t(res.data), true);
            this.disableSaveBtn = false;
          });
        } else {
          this.disableSaveBtn = true;
          updatedData.ratePlanCode = updatedData.ratePlanCode.toUpperCase();
          chainService.createRate(updatedData).then((res) => {
            if (res.responseCode == 0) {
              _alert(res, this.$t("CREATE_SUCCESS"), false);
            }
            let vm = this;
            setTimeout(function () {
              vm.$router.push({ name: "chain-rate-plan" });
            }, 1000);
            if (res.responseCode != 0) {
              this.disableSaveBtn = false;
              _alert(res, this.$t(res.data), false);
            }
          });
        }
      }
    },
    back() {
      this.$router.back();
    },
    addnotApplyDates() {
      this.editedItem.rateBlackouts.push({
        startDate: null,
        endDate: null,
      });
    },
    removeRangeApplyDate(index) {
      this.editedItem.rateBlackouts.splice(index, 1);
    },
    addRateCancellationsAddIds(item) {
      var tmp = this.rateCancellationsAddIds.map((x) => x.id);
      if (!tmp.includes(item.id)) {
        this.rateCancellationsAddIds.push(item);
      }
    },
    updateRateCancellationsAddIds(item) {
      var tmp = this.editedItem.rateCancellations.map((x) => x.cancellationId);

      if (tmp.includes(item.id)) {
        this.editedItem.rateCancellations.splice(tmp.indexOf(item.id), 1);
      }

      var tmp = this.rateCancellationsAddIds.map((x) => x.id);
      if (!tmp.includes(item.id)) {
        this.rateCancellationsAddIds.push(item);
      }
    },
    addRatePaymentsAddIds(item) {
      var tmp = this.ratePaymentsAddIds.map((x) => x.id);
      if (!tmp.includes(item.id)) {
        this.ratePaymentsAddIds.push(item);
      }
    },
    updateRatePaymentsAddIds(item) {
      var tmp = this.editedItem.ratePayments.map((x) => x.depositeId);

      if (tmp.includes(id)) {
        this.editedItem.ratePayments.splice(tmp.indexOf(id), 1);
      }
      var tmp = this.ratePaymentsAddIds.map((x) => x.id);
      if (!tmp.includes(item.id)) {
        this.ratePaymentsAddIds.push(item);
      }
    },
    currentDate() {
      let today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //As January is 0.
      var yyyy = today.getFullYear();

      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;

      return yyyy + "-" + mm + "-" + dd;
    },
    isCancelSelected(id) {
      if (this.clone.editedItem.rateCancellations.length >= 0) {
        let temp = this.clone.editedItem.rateCancellations.map(
          (x) => x.cancellationId
        );
        if (temp.includes(id)) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    isPaymentSelected(id) {
      if (this.clone.editedItem.ratePayments.length >= 0) {
        let temp = this.clone.editedItem.ratePayments.map((x) => x.depositeId);
        if (temp.includes(id)) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    removeOldCancellation(index) {
      this.editedItem.rateCancellations.splice(index, 1);
    },
    removeOldratePayments(index) {
      this.editedItem.ratePayments.splice(index, 1);
    },
    removeNewratePayments(index) {
      this.ratePaymentsAddIds.splice(index, 1);
    },
    removeNewCancellation(index) {
      this.rateCancellationsAddIds.splice(index, 1);
    },
    _formatCurrency: _formatCurrency,
  },
};
</script>
